export enum LeagueRoundResultContext {
    ROUND = 'ROUND',
    RACE = 'RACE'
}